import Vue from 'vue';
import VueRouter from 'vue-router';
import Home from '@/views/Home.vue';
import Login from '@/views/Login.vue';
import LostPassword from '@/views/LostPassword.vue'
import Subscribe from '@/views/Subscribe.vue';

import AdminLayout from "@/views/admin/AdminLayout";

import AdminProduct from "@/views/admin/product/AdminProduct";
import AdminProductColor from "@/views/admin/product/AdminProductColor";
import AdminVariant from "@/views/admin/product/AdminVariant";
import AdminModel from "../views/admin/product/AdminModel";
import AdminBookmarks from "@/views/admin/product/AdminBookmarks";

import AdminHierarchy from "@/views/admin/AdminHierarchy";

import AdminSearch from "@/views/admin/AdminSearch";

import AdminBrands from "@/views/admin/brand/AdminBrands";
import AdminBrandsOutdated from "@/views/admin/brand/AdminBrandsOutdated";
import AdminBrandsMarketplace from "@/views/admin/brand/AdminBrandsMarketplace";

import AdminUser from "@/views/admin/user/AdminUser";
import AdminUserNew from "@/views/admin/user/AdminUserNew"

Vue.use(VueRouter);

const routes = [
    {
        path: '/',
        name: 'home',
        component: Home
    },
    {
        path: '/login',
        name: 'login',
        component: Login
    },
    {
        path: '/lost-password',
        name: 'lost-password',
        component: LostPassword
    },
    {
        path: '/subscribe',
        name: 'subscribe',
        component: Subscribe
    },
    {
        path: '/admin',
        component: AdminLayout,
        children: [
            //PRODUCT
            {
                path: '',
                name: 'admin_products',
                component: AdminProduct
            },
            {
                path: 'product/variant/',
                name: 'admin_products_variant_new',
                component: AdminVariant,
            },
            {
                path: 'product/variant/:id',
                name: 'admin_products_variant',
                component: AdminVariant
            },
            {
                path: 'product/models',
                name: 'admin_products_models',
                component: AdminModel
            },
            {
                path: 'product/bookmarks',
                name: 'admin_products_bookmarks',
                component: AdminBookmarks
            },
            {
                path: 'product/color',
                name: 'admin_products_color',
                component: AdminProductColor
            },
            //HS
            {
                path: 'hierarchy',
                name: 'admin_hierarchy',
                component: AdminHierarchy
            },
            {
                path: 'search',
                name: 'admin_search',
                component: AdminSearch
            },
            //BRAND
            {
                path: 'brands',
                name: 'admin_brands',
                component: AdminBrands,
            },
            {
                path: 'brands/outdated',
                name: 'admin_brands_outdated',
                component: AdminBrandsOutdated
            },
            {
                path: 'brands/marketplace',
                name: 'admin_brands_marketplace',
                component: AdminBrandsMarketplace
            },
            //USER
            {
                path: 'users',
                name: 'admin_users',
                component: AdminUser,
            },
            {
                path: 'users/new',
                name: 'admin_users_new',
                component: AdminUserNew,
            }
        ]
    }
];

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
});

router.beforeEach((to, from, next) => {
    const authRequired = to.path.indexOf('/admin') != -1 || to.path.indexOf('/admin') != -1;
    const loggedIn = localStorage.getItem('token');

    if (authRequired && !loggedIn) {
        return next('/login');
    }

    next();
});

export default router
